
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Badge,
  Button,
  FormGroup,
  Input,
  Media,
  Modal,
  Table,
  DropdownToggle, DropdownMenu, DropdownItem , UncontrolledDropdown,
 } from "reactstrap";
import {
  Link
} from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import "assets/css/custom.css";
import ClusterService from '../../services/api/Cluster';
import HashLoader from "react-spinners/HashLoader";
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from "react-spinners/ScaleLoader";

import ReactTable from "react-table";
import "react-sweet-progress/lib/style.css"; 
import moment from 'moment'
import RunService from '../../services/api/Run';
import UserService from '../../services/api/User';
import ChatService from '../../services/api/Chat';
import { toast } from 'react-toastify';
import Dialog from 'react-dialog'
import 'react-dialog/css/index.css'
import { CopyToClipboard } from "react-copy-to-clipboard";
import TinyURL from "tinyurl";
import Linkify from 'react-linkify';
import Pagination from "../../assets/js/Pagination";
import Chip from '@material-ui/core/Chip';
import openpara from "assets/img/open.png";
// import ReactModal from 'react-modal-resizable-draggable';
import ChipInput from 'material-ui-chip-input'
import {imageFileExtension,getImageFile,getRandomRolor,millisecondToHour} from "../../settings/shared/commonMethod"
import { Scrollbars } from 'react-custom-scrollbars';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import profileIcon from '../../assets/img/proicon.png';
import StorageService from '../../services/api/Storage';
import axios from 'axios'
import { INTERVALSEARCH } from "settings/shared/constants";


const styles = {
  chaticon: {
    cursor: 'pointer'
  },
  chatbutton: {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    boxShadow: 'transparent',
  },
  expandStyles: {
    backgroundColor: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1
  },
  expandStyles_Comman: {
    backgroundColor: "#000000",
    color: "#2dce89",
    fontSize: "0.2rem",
    letterSpacing: 1,
    width: 550,
    height: 'auto',
    marginTop: 5,
    marginLeft: 30,
    marginBottom: 2
  },
  expandStyles_param: {
    fontSize: "0.8rem",
    letterSpacing: 1,
    width: 550,
    marginTop: 5,
    marginLeft: 30
  },
  logbtn: {
    backgroundColor: "#5e72e4",
    color: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1,
    borderRadius: 8,
    height: 30,
    width: 50,
    padding: 0,
    marginLeft: 10
  },
  removedialog: {
    top: '50%',
    width: '250px'
  }
}
const colours=['red', 'orange', 'yellow','blue', 'green', 'indigo', 'violet'];
class ViewCluster extends React.Component { 
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.searchTimeOut = 0;
    this.state = {
      k8sDTOSdata:[],
      clusterName:'',
      clusterDescription:'',
      clusterCreatedBy:'',
      clusterUpdatedBy:'',  
      input: "",
      messages: [],
      input_user: [],
      input_userEmail: [],
      open: false,
      products: [],
      columns: [],
      chatMsg: [],
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      logState: false,
      expanded:{},
      runname: "",
      filter: false,
      count: 0,
      logDetails: [],
      parasetm: [],
      UserList: [],
      filtered:[],
      updatePageNumber:0,
      totalPages:0,
      showuserListFlag: false,
      countitem: 0,
      rundatalength: '',
      runprojectname: '',
      copied: false,
      value: '',
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      isRunActionOpen: false,
      modalParameter: false,
      chatrundata:[],
      tags: [],
      randomcolor:'',
      DownloadUrl:'',
      myContent:'',
      fileType:'',
      swidth: window.innerWidth,
      sheight: window.innerHeight

      };
      this.onPageChange = this.onPageChange.bind(this);
      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  this.state.columns = [
    {
    Header: 'Name',
    accessor: 'Name',
    maxWidth: 120,
    sortable: true,
     }, 
     {
      Header: 'Id',
      accessor: 'Id',
      sortable: true,
      maxWidth: 100,
    }, 
    {
    Header: 'RunTime',
    accessor: 'RunTime',
    maxWidth: 100,

  },
  {
    Header: 'Cluster',
    accessor: 'Cluster',
    maxWidth: 100,

  },
  {
    Header: 'Status',
    accessor: 'Status',
    maxWidth: 100,
  },
    {
    Header: 'StartTime',
    accessor: 'StartTime',
    maxWidth: 150,
  },
  {
    Header: 'EndTime',
    accessor: 'EndTime',
    maxWidth: 150,
  },
  {
    Header: 'Cost',
    accessor: 'Cost',
    maxWidth: 100,
  },
  {
    Header: 'Created By',
    accessor: 'CreatedBy',
    maxWidth: 150,
  },
];
  if(this.state.percent < 30){
    this.state.status= "success"
  }
  if(this.state.percent >= 30){
    this.state.status= "active"
  }
  if(this.state.percent >= 70){
    this.state.status= "error"
  }
};
  
  componentDidMount() {
    let currentUrl = window.location.href;
    let viewClusterId = currentUrl.substring(currentUrl.lastIndexOf("/") + 1)
    this.setState({
      viewClusterId:viewClusterId
   });
   this.GetClusterByID(viewClusterId);
   this.GetRunsData(viewClusterId)
   this.updateWindowDimensions();
window.addEventListener('resize', this.updateWindowDimensions);

  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

GetClusterByID = (viewClusterId) =>{
  this.setState({ loading: true });
    ClusterService.clusterLiveStatus(viewClusterId).then((response) => {
      if (response.status === 'SUCCESS') {
        let k8sDTOS = response.k8sDTOS;
        if (k8sDTOS.length > 0) {
          this.setState({
            clusterName: k8sDTOS[0].name,
            clusterDescription: k8sDTOS[0].description,
            clusterCreatedBy: k8sDTOS[0].createdBy,
            clusterUpdatedBy: k8sDTOS[0].updatedDate,
            loading: false
          })
        }
        }else{
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }  
     });  
  }

 GetRunsData = (viewClusterId) => {
  this.setState({ loading: true });
  let postData = {
    clusterId: viewClusterId
  }
  let size = 10;
  RunService.getRunbySize(postData,this.state.updatePageNumber,size)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let runSDTO = response.runDetails.content;
        this.renderData(runSDTO);
        this.setState({ loading: false, socketLoadFlag: false ,totalPages:response.runDetails.totalPages });// To load table data in to product array
      } else {
        this.setState({ loading: false, socketLoadFlag: false,totalPages:response.runDetails.totalPages });// To load table data in to product array    
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    })
}

//Display Run table
renderData(runData){
  this.setState({ loading: true });
  let datas = [];
  this.state.products = [];
  this.state.rundatalength = runData.length;
  this.state.runprojectname = "Demo Project"
  runData.map((item, index) => {
    if (item.runStatus === "Cancelled") {
      this.setState({ disabled: 'disabled' });
    } else if (item.runStatus === "Completed") {
      this.setState({ disabled: 'disabled' });
    } else if (item.runStatus === "Failed") {
      this.setState({ disabled: 'disabled' });
    } else {
      this.setState({ disabled: 'false' });
    }
    this.state.runname = item.name;
    let PrefixCodeFiles = [];
    if(item.codeFilesPrefix === null){
      PrefixCodeFiles = item.modelCodeFiles
    }else if(item.codeFilesPrefix.length > 0){
      var pre = item.codeFilesPrefix;
      var arr = item.modelCodeFiles
      var newArr = (pre + arr.join(';' + pre)).split(';');
      PrefixCodeFiles = newArr;
    }else{
      PrefixCodeFiles = item.modelCodeFiles
    }
    if(item.hideCodeCells === true ){
      this.setState({hideCodeCells:"true"})
      }
     else{
      this.setState({hideCodeCells:"false"})
    }

    datas.push({
      Name: 
      // <span title={item.name} className="overflowStyle overflowStyleWithIcon" key={item.name}>{item.name}</span>,
      <span title={item.name} className="overflowStyle" key={item.name}>{item.name}</span>,
      fullName:item.name,
      Id: item.jobId, Description: item.description, 
      RunTime: <span className="overflowStyle">{millisecondToHour(item.runTimeInMilliseconds,item.runStatus)}</span>,   
      Cluster: <span title={item.clusterName} className="overflowStyle">{item.clusterName}</span>,
      hideCodeCells: this.state.hideCodeCells,
      Status:
        <div key={item.runStatus}>

          {(item.runStatus === "Starting" || item.runStatus === "Progress") &&
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Executing" &&
            <Badge color="" className="badge-dot"><i className="bg-success blink" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Cancelled" &&
            <Badge color="" className="badge-dot"><i className="bg-darkgray" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Completed" &&
            <Badge color="" className="badge-dot"><i className="bg-blue" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Failed" &&
            <Badge color="" className="badge-dot"><i className="bg-red" />{item.runStatus}</Badge>
          }

        </div>

      , Cost: item.cost,
      DbId:item.id,
      scheduleId:item.scheduleId,
      createdBy: <span title={item.createdBy} className="overflowStyle">{item.createdBy}</span>,
      InputFile: item.modelInputFiles || [],
      InputFolders: item.modelInputFolders || [],
      CodeFile: PrefixCodeFiles || [],
      CodeFolders: item.modelCodeFolders || [],
      modelOutputCodeFiles: item.modelOutputCodeFiles != null?item.modelOutputCodeFiles:[],
      modelOutputCodeFolders: item.modelOutputCodeFolders != null?item.modelOutputCodeFolders:[],  //new
      OutputFile: item.modelOutputFiles != null?item.modelOutputFiles:[], 
      modelOutputFolders: item.modelOutputFolders != null?item.modelOutputFolders:[],   //new
      Tags:item.tags || [],
      LogFiles: item.logEntries,
      Parameter: item.parameterSet,
      StartTime: <div key={item.startTime}>	{item.startTime != null ? moment.utc(item.startTime).local().format('MMM DD, YYYY') : ""} <br></br>{item.startTime != null ? moment.utc(item.startTime).local().format('hh:mm A') : ""}<br /></div>, EndTime: <div key={item.endTime}>{item.endTime != null ? moment.utc(item.endTime).local().format('MMM DD, YYYY') : ""}<br></br> {item.endTime != null ? moment.utc(item.endTime).local().format('hh:mm A') : ""}</div>,
      Comments: <div className="">  <button className="btn-icon-only text-blue" size="sm" role="button"
        color="" style={styles.chatbutton}
        onClick={e => this.CallJobRun(item.jobId,item.chatMasterId,item.chatMasterIdentifier,item.name)}

     >
        <i className="far fa-comments text-blue" />
         {this.displayUnreadCount(item.chatMasterId)}
      </button> </div>,
      Action:
        <div className="">
       <div className="row">  <span className="" style={{cursor:'pointer'}}  onClick={e => {e.preventDefault()
        this.updateRerun(item.id, item.masterJobId)}}>Rerun | &nbsp;</span> 
          <UncontrolledDropdown >  
                                  <DropdownToggle
                                  tag="span"
                                      onClick={e => e.preventDefault()}
                                      onContextMenu={e => e.preventDefault()}
                                      style={{color: '#007bff',cursor:'pointer'}}
                                  >
                                  <i className="fas fa-ellipsis-v" />
                                  </DropdownToggle>
                                  <DropdownMenu 
                                  right
                                    className="dropdown-menu-arrow"
                                  >
                                   <DropdownItem
                                      href=""
                                      onClick={e => {e.preventDefault()
                                      this.cloneProject(item.masterJobId,item.name)}}
                                    >
                                    <span> 
              <i className="far fa-clone text-red mr-3" /> Clone as Project
              </span>
                                    </DropdownItem>
                                     <DropdownItem
                                       onClick={e => this.jobCancelConfirmation(item.jobId, item.id)}
                                      className={this.state.disabled}
                                    >
                                    <span> 
                              <i className="fas fa-times text-red mr-3" /> Cancel Job 
                              </span>
                                    </DropdownItem>
                                    <DropdownItem
                                     onClick={e => this.jobRemoveConfirmation(item.jobId, item.id)}
                                    >
                                    <span> <i className="fas fa-archive text-red mr-3"></i>
                               Remove Job 
                              </span>
                                    </DropdownItem>
                                  </DropdownMenu>
                  </UncontrolledDropdown> 

        </div>
        </div>
    })
  });
  this.setState({
    products: datas,
    loading:false,
  });
 
}


onPageChange(pageIndex) {
  this.setState({
    updatePageNumber:pageIndex,
  },()=>{
    if(this.state.filtered.length !== 0){
      this.filterMethod(this.state.filtered)
    }else{
      this.GetRunsData(this.state.viewClusterId)
    }
  });
}

changeColumnName = (column) =>{
  let ColumnName = ""
  if(column === "Name"){ColumnName="name"}
  if(column === "RunTime"){ColumnName="runTime"}
  if(column === "Cluster"){ColumnName="clusterName"}
  if(column === "Id"){ColumnName="jobId"}
  if(column === "Status"){ColumnName="runStatus"}
  if(column === "StartTime"){ColumnName="startTime"}
  if(column === "EndTime"){ColumnName="endTime"}
  if(column === "createdBy"){ColumnName="createdBy"}
  return ColumnName;
}

  filterMethod = (filter) => {
    this.setState({ filtered: filter }, () => {
      if (this.state.filtered.length === 2) {
        this.state.filtered.splice(0, 1);
      }
    })
    if (filter.length !== 0) {
      if (filter[filter.length - 1].id === "Id" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].id === "RunTime" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].value.length > 2) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      }
    } else {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.GetRunsData(this.state.viewClusterId);
      }, 1500);
    }
  }

filterDataLoadDelay = (filter,pageNumber) =>{
  if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.filterDataLoad(filter,pageNumber)

    }, 300);
}

async filterDataLoad(filter, pageNumber) {
  let size = 15;
  var runData = {};
  if(this.changeColumnName(filter[filter.length - 1].id) === "name" || this.changeColumnName(filter[filter.length - 1].id) === "jobId"){
    runData["jobIdOrNameStartsWith"] = filter[filter.length - 1].value
  }else{
    runData[this.changeColumnName(filter[filter.length - 1].id)] = filter[filter.length - 1].value
  }
  runData["projectIds"] = []
  if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = await new Promise(resolve => setTimeout(resolve, INTERVALSEARCH));
    const response = await RunService.getRunSearch(runData, pageNumber, size);
    if (response.status === 'SUCCESS') {
      let runSDTO = response.runDetails.content;
      this.renderData(runSDTO);
      this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
    } else {
      this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
    }
};

FilterData = () => {
  this.setState({ count: this.state.count + 1 });
  if (this.state.count % 2 === 0) {
    this.setState({ filter: true });
  }
  else {
    this.setState({ filter: false });
  }
}

addChip = (id,value,tags) => {
  var i= Math.floor(Math.random()*colours.length); 
  var getData = this.state.products.filter(item=>item.DbId === id);
  var index = this.state.products.findIndex(function(item, i){
    return item.DbId === id
  });
  getData[0].Tags.push(value)
  this.state.products[index]=getData[0];
  this.setState({products:this.state.products,
  randomcolor:colours[i]})
  this.CreateTags(id,tags);
};
getColor = () =>{
  let colorCode = getRandomRolor();
 return colorCode;
}

removeChip = (id,index) => {
  var getData = this.state.products.filter(item=>item.DbId===id);
  var productIndex = this.state.products.findIndex(function(item, i){
    return item.DbId === id
  });
  getData[0].Tags.splice(index,1)
  this.state.products[productIndex]=getData[0];
  this.setState({products:this.state.products})
  this.CreateTags(id,getData[0].Tags);
};


CreateTags = (id,tags) =>{
  RunService.createTags(id,tags)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        // toast.success("Tags Updated Successfully!");
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
}


CallJobRun = (jobrunid,masterId,chatMasterIdentifier,name) => { 
    let reg = "/cluster/all/";
    localStorage.setItem("Pagehistory","/cluster/all/");
    this.props.history.push("/job/"+chatMasterIdentifier+"?__o="+reg)
    
}

displayUnreadCount (chatmasterId){
  let chatCount = 0;
  if(chatmasterId === null || chatmasterId === undefined){
     chatCount = 0;
   }else{
       var filterData = this.state.chatrundata.filter(f=>f.chatMasterId === chatmasterId);
       chatCount = filterData[0] !== undefined?filterData[0].totalUnreadMessages:0;          
     }
  return <span>{chatCount !== 0 && <sup><span className="badge badge-success">{chatCount}</span></sup>}</span>
}

GetChatUnreadCount (){
  if (!this.state.socketLoadFlag) {
   this.setState({ loading: true });
 }
  ChatService.GetChatRunIds(0,2)
 .then((res) => {
   if(res !== ""){  // if chat response is 204 execure this condtion
     let size = res.totalItems;
     ChatService.GetChatRunIds(0,size).then((response) => {
     this.setState({chatrundata:response.chatItems},()=>{
         this.GetRunsData(this.state.viewClusterId);
       })
     });  
   }else{
    //  console.log("end scroll")
     this.GetRunsData(this.state.viewClusterId);
   }
 })
}

handleDelete = (item) => {
  var index_user = this.state.input_user.indexOf(item);
  var index_email = this.state.input_userEmail.findIndex(obj => obj['user'] === item);
  this.state.input_user.splice(index_user, 1);
  this.state.input_userEmail.splice(index_email, 1);
  this.setState({
    input_user: this.state.input_user,
    input_userEmail: this.state.input_userEmail
  })
  if (this.state.input_user.length === 0) {
    let uId = localStorage.getItem("Uid");
    this.GetAllUsers(uId);
  }
};

userselectedValue = (firstName, lastName, email) => {
  let myappendUser = "@" + firstName + " " + lastName
  let selectedEmail = { user: myappendUser, email: email };
  const filteredArray = this.state.UserList.filter((res) => res.firstName !== firstName);
  this.setState({
    input: "",
    input_userEmail: [...this.state.input_userEmail, selectedEmail],
    input_user: [...this.state.input_user, myappendUser],
    UserList: filteredArray
  })
}
keyPressed = (event) => {
  if (event.keyCode === 13) {
    this.submitMessage()
  } else if (event.keyCode === 50) {
    this.setState({ showuserListFlag: true });
  } else {
    this.setState({ showuserListFlag: false });
  }
}

submitMessage = () => {
  let emailList = [];
  for (let i = 0; i < this.state.input_userEmail.length; i++) {
    emailList.push(this.state.input_userEmail[i].email);
  }
  let chatPaylad = {
    "runDBId": this.state.chatDbId,
    "message": this.state.input_user + " " + this.state.input,
    "mentionedUsers": emailList
  }
  RunService.Postchat(chatPaylad)
    .then((response) => {
      this.setState(
        {
          messages: [...this.state.messages, this.state.input_user + " " + this.state.input],
          input: "",
          input_user: [],
          input_userEmail: []
        }
      );
    })
  let uId = localStorage.getItem("Uid");
  this.GetAllUsers(uId);
}

clearMessages = () => {
  this.setState({ messages: [] });
}

handleClose = () => {
  this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false,  modalParameter:false })
}

// cancel job
jobCancelConfirmation = (jobId, cancelId) => {
  confirmAlert({
    title: 'Cancel Job',
    message: 'Are you sure to cancel this job -' + jobId + '?',
    buttons: [
      {
        label: 'Yes',
        onClick: e => this.HandlingAction(cancelId)
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}

  // Handling cancel job actions
  HandlingAction = (uid) => {
    if (uid !== undefined && uid !== null) {
      let JobPayload = {
        id: uid
      }
      RunService.cancelJob(JobPayload)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetRunsData(this.state.viewClusterId); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }
  }

// Download particular file in input or code
downloadparticularFiles = (fileName, rid, type) => {
  StorageService.downloadObjectUrl(fileName) 
  .then((response) => {
    const link = document.createElement('a');
    link.href = response.download_url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

  // Hide and Show Log for each run
  HideandShowLog(flag,fileName, log) {
    this.setState({ modalloading:true ,myContent:''});
  let filepath = "jobs/"+fileName+"/logs/console.log"
    StorageService.downloadObjectUrl(filepath)
    .then((response) => {
      this.renderText(response.download_url);
      this.setState( { modalloading:false,DownloadUrl:response.download_url} );
    }).catch((error) => {
      this.setState({ modalloading:false });
    });;
    this.setState({
      logState: !flag,
      isDialogOpen: true,
      logDetails: log
    })
  }
  renderText = (url) => {
    axios.get(url)
    .then(response => {
    this.setState({
      fileType:"others",
      myContent:response.data.toString()
      })
    })
    .catch(error => {
      // console.log(error);
      return error;
    });
}

openModal() {
  this.setState({modalIsOpen: true});
}
closeModal() {
  this.setState({modalIsOpen: false,modalParameter:false });
}
onOpenModal = (runId, commentid) => {
  this.setState({
    open: true,
    chatDbId: runId
  });
  this.LoadChats(runId);
  this.state.commentid = commentid;
};

onCloseModal = () => {
  this.setState({ open: false });
};

// Load all chats for particular run id
LoadChats = (runId) => {
  let profile = JSON.parse(localStorage.getItem("UserProfile"));
  this.setState({
    localName: profile.firstName + " " + profile.lastName,
    localPhoto: profile.photoURL,
    input: '',
    messages: []
  });
  RunService.GetChats(runId)
    .then((response) => {
      this.state.countitem = response.length;
      this.setState({
        chatMsg: response
      })
      let uId = localStorage.getItem("Uid");
      this.GetAllUsers(uId);
    })
}

GetAllUsers = (allid) => {
  UserService.getAllUsers(this.state.usersid)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
        let users = []
        let i;
        for (i = 0; i < response.userDTOS.length; i++) {
          if (loggedInUser.email !== response.userDTOS[i].email) {
            users.push(response.userDTOS[i])
          }
        }
        this.setState({
          UserList: users
        });

      } else {
        // console.log(response.errorMessage);
      }
    })
}
OpenStorageView = (name, event, hidevalue) => {
  event.preventDefault()
  localStorage.setItem("filePathStorage", name);
  let currentUrl = window.location.href;
  let reg = "/cluster/viewcluster/"+this.state.viewClusterId;
  let path = name.slice(-1) === "/"?"/storage?path="+name:"/storageView?file="+name + "&hideCodeCells=" + hidevalue;  // check folder or file
  let redirectUrl = currentUrl.replace(reg, path);
  window.open(redirectUrl, "_blank");
}

copyAlert = () => {
  toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 


}

onClickSchedulerId = (id) => {
  this.props.history.push("/schedule?id="+id+"&scheduleFor=runs")
}

GetLink = (name,event) => {
  event.preventDefault()
  localStorage.setItem("filePathStorage", name);
  let currentUrl = window.location.href;
  let reg = "/cluster/viewcluster/";
  let redirectUrl = currentUrl.replace(reg, "/storageView?file="+name);

  TinyURL.shorten(redirectUrl).then((res) =>{
    this.ShareURL(res, name);
  })
}

ShareURL = (tinylink, fileName) => {
  this.setState({ gettinylink: tinylink });
  this.state.copylink = tinylink;
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row >
                    <div className="col">
                    <h6><i className="fas fa-link"></i>&nbsp; Get Link </h6>
                    </div>
                    <div className="col text-right">
                      <div>
                        <span className="close clear-filter" style={{ cursor: "pointer" }} onClick={() => { onClose() }}>×</span>
                      </div>

                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">

                      <FormGroup>
                        <Input className="form-control-alternative" style={{ width: '260px' }} value={tinylink}
                          onChange={({ target: { value } }) => this.setState({ value, copied: false })} />

                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <CopyToClipboard text={tinylink}
                          onCopy={() => this.setState({ copied: true })}>
                          <p style={{ cursor: "pointer" }} onClick={this.copyAlert}><b>Copy Link</b></p>
                        </CopyToClipboard>
                      </FormGroup>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      )
    }
  });
}


clickOnAction = (event) => {
  event.preventDefault()
}

jobRemoveConfirmation = (jobId, removeId) => {
  confirmAlert({
    title: 'Remove Job',
    message: 'Are you sure to remove this job -' + jobId + '?',
    buttons: [
      {
        label: 'Yes',
        onClick: e => this.RemoveAction(removeId)
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}

updateRerun = (id, masterJobId) => {
  
  this.props.history.push({
    pathname: '/newProject',
    state: { mode: "reRun", rerunId: id, projectId: masterJobId}
  })
}
cloneProject = (masterJobId,name) =>{
  this.props.history.push({
  pathname: '/newProject',
  state: { mode:"cloneProject",editId:masterJobId,editProject:name}
  })
}

openDialog = (itemid) => {
  this.setState({ isDialogOpen: true, dialogid: itemid })
  this.state.dialogid = itemid;
}

onDismiss = () => { };
toggleModalParameter = (paraset) => {
  this.setState({
    modalParameter: !this.state.modalParameter,
    parasetm:paraset
  });
};
  // Handling remove job actions
  RemoveAction = (rid) => {
    if (rid !== undefined && rid !== null) {
      let RemoveJobdto = {
        id: rid
      }
      RunService.removeJob(RemoveJobdto)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetRunsData(this.state.viewClusterId); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }
  }

  handleClick = (e) => {
    e.preventDefault();
      if(e.type === "contextmenu") {
        var arrt = e.currentTarget.getAttribute("data_attr_id");
        document.getElementById(arrt).click();
    }  
  }

render() {
  const { open } = this.state;
    return (
  
      <>
        <PanelHeader
          content={
            <div className="header text-center">           
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                      <div className="col">
                        <span className="text-center"><b>{this.state.clusterName} </b> </span>
                      </div>
                      <div className="col text-right">
                        <Link to="/cluster/all/" >
                          <span className="close clear-filter">×</span>
                        </Link>
                      </div>
                    </Row>               
                </CardHeader>
                <CardBody>  

                <div className="carcontent pc-blocks">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-180}>

                <Row>
            <Col lg="3" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <div className="statistics statistics-horizontal">
                    <div className="info info-horizontal">
                      <Row>
                        <Col xs="3" lg="5" xl="3">
                          <div className="icon icon-primary icon-circle">
                            <i className="fas fa-dharmachakra" />
                          </div>
                        </Col>
                        <Col className="" xs="9" lg="7" xl="9">
                        <h5 className="info-title">Cluster Name</h5>
                        <span className="stats-title">{this.state.clusterName}</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
                
              </Card>
            </Col>
            <Col lg="3" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <div className="statistics statistics-horizontal">
                    <div className="info info-horizontal">
                      <Row>
                        <Col xs="3" lg="5" xl="3">
                          <div className="icon icon-warning icon-circle">
                            <i className="now-ui-icons design_bullet-list-67" />
                          </div>
                        </Col>
                        <Col className="" xs="9" lg="7" xl="9">
                          <h5 className="info-title">Description</h5>
                          <span className="stats-title">{this.state.clusterDescription}</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
                
              </Card>
            </Col>
            <Col lg="3" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <div className="statistics statistics-horizontal">
                    <div className="info info-horizontal">
                      <Row>
                        <Col xs="3" lg="5" xl="3">
                          <div className="icon icon-success icon-circle">
                          <i className="now-ui-icons users_single-02"></i>
                          </div>
                        </Col>
                        <Col className="" xs="9" lg="7" xl="9">
                          <h5 className="info-title">Created By</h5>
                          <span className="stats-title">{this.state.clusterCreatedBy}</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
                
              </Card>
            </Col>
            <Col lg="3" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <div className="statistics statistics-horizontal">
                    <div className="info info-horizontal">
                      <Row>
                        <Col xs="3" lg="5" xl="3">
                          <div className="icon icon-info icon-circle">
                            <i className="fas fa-file-signature"/>
                          </div>
                        </Col>
                        <Col className="" xs="9" lg="7" xl="9">
                          <h5 className="info-title">Last Modified</h5>
                          <span className="stats-title">{this.state.clusterUpdatedBy != null ?moment.utc(this.state.clusterUpdatedBy).local().format('MMM DD, YYYY') : ""} {this.state.clusterUpdatedBy != null ? moment.utc(this.state.clusterUpdatedBy).local().format('hh:mm A') : ""}</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
                
              </Card>
            </Col>
          </Row>
          {/* <Row>
          <Col lg="3" sm="6">
          <Card className="card-contributions activejobs">
              <CardBody>
                <span className="spantxt">
                      <b> Number of Active Jobs : </b> 2
                    </span>
              </CardBody>
          </Card>
          </Col>
          <Col lg="3" sm="6">
          <Card className="card-contributions completedjobs">
              <CardBody>
                <span className="spantxt">
                  <b> Number of Completed Jobs : </b> 5
                </span>
              </CardBody>
          </Card>
          </Col>
          <Col lg="3" sm="6">
          <Card className="card-contributions failedjobs">
              <CardBody>
                <span className="spantxt">
                <b>Number of Failed Jobs : </b> 2
                </span>
              </CardBody>
          </Card>
          </Col>
          <Col lg="3" sm="6">
          <Card className="card-contributions totaljobs">
              <CardBody>
                <span className="spantxt">
                <b> Number of Total Jobs : </b> 9
                </span>
              </CardBody>
          </Card>
          </Col>
          </Row>
           */}
            <br></br>
            <Row className="mt-12">
            <hr />

            <Col className="mb-12 mb-xl-0" id="closeDialog" xl="12">
            <span className="text-center"><b>Cluster Run Table </b> </span>
              <div className="table-responsive">
              <br></br>
              <ReactTable
                      PaginationComponent={Pagination}
                      onFilteredChange={filtered => this.filterMethod(filtered)}
                      filtered={this.state.filtered}
                      data={this.state.products}
                      manual
                      expanded={this.state.expanded}
                          onExpandedChange={(expanded, index, event) => {
                          this.setState({expanded});            
                        }}
                      columns={
                        [
                          {
                            Header: "",
                            columns: [
                              {
                                expander: true,
                                Header: () => <strong className="filterdata" onClick={e => this.FilterData()}>&nbsp; &nbsp; &nbsp;<i className="fas fa-filter"></i> </strong>,
                                width: 60,
                                Expander: ({ isExpanded, ...rest }) =>
                                  <div>

                                    {isExpanded
                                      ? <span>-</span>
                                      : <span>+</span>}
                                  </div>,
                                style: {
                                  cursor: "pointer",
                                  fontSize: 20,
                                  padding: "0",
                                  textAlign: "center",
                                  userSelect: "none"
                                },
                              }
                            ]
                          },
                          {
                            id: "scheduler",
                            accessor: "",
                            Cell: ({ original}) => {
                              return (   
                              original.scheduleId !== null && <i className="far fa-clock" style={{verticalAlign:"baseline",color:"#4776d9"}}/>
                              );
                            },
                            sortable: false,
                            width: 20,
                          
                          },
                          {
                            Header: 'Name',
                            accessor: 'Name',
                            maxWidth: 400,
                            filterable: this.state.filter,
                            },
                            {
                              Header: 'Tags',
                              accessor: 'Tags',
                              show:false
                              },
                              {
                                Header: 'fullName',
                                accessor: 'fullName',
                                show: false
                            
                              },    
                              {
                                Header: 'DbId',
                                accessor: 'DbId',
                                show:false
                                },
                          {
                            Header: 'Id',
                            accessor: 'Id',
                            maxWidth: 70,
                            filterable: this.state.filter,
                          }
                          , {
                            Header: 'Description',
                            accessor: 'Description',
                            show: false
                          }, {
                            Header: 'RunTime',
                            accessor: 'RunTime',
                            maxWidth: 120,
                            filterable: this.state.filter,

                          }, {
                            Header: 'Cluster',
                            accessor: 'Cluster',
                            maxWidth: 80,
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'hideCodeCells',
                            accessor: 'hideCodeCells',
                            show: false
                          },
                          {
                            Header: 'Status',
                            accessor: 'Status',
                            maxWidth: 100,
                            filterable: this.state.filter,
                          }, {
                            Header: 'StartTime',
                            accessor: 'StartTime',
                            filterable: this.state.filter,
                          }, {
                            Header: 'EndTime',
                            accessor: 'EndTime',
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'scheduleId',
                            accessor: 'scheduleId',
                            show: false
                          },
                          {
                            Header: 'Cost',
                            accessor: 'Cost',
                            sortable: true,
                            filterable: this.state.filter,
                            maxWidth: 100
                          }, {
                            Header: 'createdBy',
                            accessor: 'createdBy',
                            maxWidth: 400,
                            filterable: this.state.filter,
                          }, {
                            Header: 'Comments',
                            accessor: 'Comments',
                            maxWidth: 90
                          },
                          {
                            Header: 'Action',
                            accessor: 'Action',
                            maxWidth: 90
                          },
                          {
                            Header: 'InputFile',
                            accessor: 'InputFile',
                            show: false
                          },
                          {
                            Header: 'InputFolders',
                            accessor: 'InputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFile',
                            accessor: 'CodeFile',
                            show: false
                          },
                          {
                            Header: 'modelOutputCodeFolders',
                            accessor: 'modelOutputCodeFolders',
                            show: false
                          },
                          {
                            Header: 'modelOutputFolders',
                            accessor: 'modelOutputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFolders',
                            accessor: 'CodeFolders',
                            show: false
                          },
                          {
                            Header: 'OutputFile',
                            accessor: 'OutputFile',
                            show: false
                          }, {
                            Header: 'modelOutputCodeFiles',
                            accessor: 'modelOutputCodeFiles',
                            show: false
                          },
                          {
                            Header: 'Parameter',
                            accessor: 'Parameter',
                            show: false
                          },
                          {
                            Header: 'LogFiles',
                            accessor: 'LogFiles',
                            show: false
                          },

                        ]

                      }
                      defaultSorted={[
                        {
                          id: "StartTime",
                          desc: true
                        }
                      ]}
                      defaultPageSize={10}
                      pages={this.state.totalPages}
                      onPageChange={this.onPageChange}
                      SubComponent={(v) => <div>
                        <br />
                        <Row>
                          <Col lg="1"><span><b>Name :</b></span></Col>
                          <Col lg="3"><span >{v.row.fullName}
                          </span></Col>
                          <Col lg="4"><span><b>Description :</b>&nbsp; &nbsp; &nbsp; {v.row.Description}</span></Col>
                          <Col lg="4">{v.row.scheduleId !== null &&<span style={{marginLeft:10}} onClick={e=>this.onClickSchedulerId(v.row.scheduleId)}><a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="far fa-clock pr-1" style={{ color: "#4776d9"}}></i>Scheduler Details</u> </a></span>}</Col>                          {/* <Col lg="1"><span><b>Name :</b></span></Col>
                          <Col lg="4"><span >{v.row.Name}</span></Col>
                          <Col lg="2"><span><b>Description :</b></span></Col>
                          <Col lg="2"><span >{v.row.Description}</span></Col> */}
                        </Row>
                        <br />   
                        <Row>
                           <Col lg="1" style={{marginTop:10}}><span><b>Tags :</b></span></Col>
                           <Col lg="10">
                           <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                           {v.row.Tags.map((item, index) => (
                           <Chip
                            key={"clu-tag-" + index}
                            label={item}
                            size="small"
                            onDelete={(chip) => this.removeChip(v.row.DbId,index)}
                            style={{background:this.getColor(),color:"#fff",fontWeight:600,marginTop:5,marginLeft:3}}
                          />))}
                           <ChipInput
                              value={v.row.Tags}
                              placeholder="Add a Tag"
                              onAdd={value => this.addChip(v.row.DbId,value,v.row.Tags)}
                            />
                             </Scrollbars><br/>
                             {/* <TagsInput value={v.row.Tags} onChange={evt => this.handleChangeTags(v.row.DbId, evt)}/> <br/> */}
                             {/* <Button className="tag-update-btn" onClick={e => this.CreateTags(v.row.DbId,v.row.Tags)}>Update</Button></Col> */}
                             </Col>
                             <Col lg="1"></Col>
                        </Row>
                        <br /> 
                        <div>{(v.row.InputFile.length !== 0 || v.row.InputFolders.length > 0) &&
                          <span ><br /> <b>Model Input Files :</b> <br />
                            <Table>
                                <tr><td>
                            <div className={(v.row.InputFile.length + v.row.InputFolders.length) > 7 ? "scorllit" : ""}>
                            <ul>
                            {v.row.InputFolders.map((item, index) => (
                              <li key={"In-fol-" + index} style={{marginTop:10}} className="listyle">
                              <span
                              className="file"
                              data-type="folder"
                              // onClick={onFileClick}
                              onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                              >
                                <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                            {v.row.InputFile.map((item,index) => (
                              <ul key={"In-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"u"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"u"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
          </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
          </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e)}>
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                  </li>
                              </ul>
                            ))}
                            </div>
                        </td>
                        </tr>
                      </Table>
                     </span>
                        }
                        </div>
                        <br />
                        <div>{(v.row.CodeFile.length > 0 || v.row.CodeFolders.length > 0) &&
                          <span ><b>Model Code Files :</b> <br />
                           <Table>
                                <tr><td>
                               <div className={(v.row.CodeFile.length + v.row.CodeFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.CodeFolders.map((item, index) => (
                                   <li key={"code-fol-" + index} style={{marginTop:10}} className="listyle">
                                   <span
                                   className="file"
                                   data-type="folder"
                                   // onClick={onFileClick}
                                   onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            {v.row.CodeFile.map((item,index) => (
                              <ul key={"code-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"r"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"r"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => { this.GetLink(item, e) }}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>

                                        {/* {this.state.copied ? <span style={{color: 'red'}}>Copied.</span> : null} */}



                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                            </div>
                            </td>
                            </tr>
                            </Table>
                          </span>
                         }
                        </div>

                        <div>{v.row.OutputFile.length !== 0 &&
                          <span ><b>Model Output Files :</b> <br />
                            <Table>
                                <tr><td>
                                  <div className={(v.row.OutputFile.length + v.row.modelOutputFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.modelOutputFolders.map((item, index) => (
                                   <li key={"model-fol-" + index} style={{marginTop:10}} className="listyle">
                                   <span
                                   className="file"
                                   data-type="folder"
                                   // onClick={onFileClick}
                                   onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            <div>
                            {v.row.OutputFile.map((item,index) => (
                              <ul key={"model-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"s"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"s"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                             </div>
                             </div>
                             </td>
                             </tr>
                             </Table>
                          </span>
                        }
                        </div>

                        <div>{v.row.modelOutputCodeFiles.length !== 0 &&
                          <span ><b>Model Output Code Files :</b> <br />
                             <Table>
                                <tr><td>
                                <div className={(v.row.modelOutputCodeFiles.length + v.row.modelOutputCodeFolders.length) > 7 ? "scrollit" : ""}>
                               <ul>
                                 {v.row.modelOutputCodeFolders.map((item, index) => (
                                   <li key={"mout-fol-" + index} style={{marginTop:10}} className="listyle">
                                   <span
                                   className="file"
                                   data-type="folder"
                                   // onClick={onFileClick}
                                   onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                   >
                                     <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                   </span>
                                   </li>
                                 ))}
                                </ul>
                            <div>
                            {v.row.modelOutputCodeFiles.map((item,index) => (
                              <ul key={"moutcode-file-" + index}>
                                <li className="listyle">
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"t"}
                                  onContextMenu={this.handleClick}>
                                  <span className="text-primary"><i
                                      className={getImageFile(imageFileExtension(item))}></i></span>
                                  <a href={()=> false} className="text-primary" style={styles.chaticon} ><u>{item}</u>
                                  </a>
                                </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"t"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                    <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            ))}
                            </div>
                            </div>
                         </td>
                         </tr>
                         </Table>
                          </span>
                        }
                        </div>


                        <Row>
                          <Col lg="2">{v.row.Parameter !== "" && <span><b>Parameters :</b></span>}</Col>
                          <Col lg="4"><span > 
                          {
                            <Scrollbars autoHeight>
                              <div>{v.row.Parameter !== null && <p style={{ marginLeft: 5, fontSize: "0.80rem", marginBottom: 10, lineHeight: 2 }}>
                                {
                                  v.row.Parameter.split("\n").map((i, key) => {
                                    return <div key={"param-split-" + key}>{i}</div>;
                                  })}
                              </p>}</div>
                            </Scrollbars>
                          }</span></Col>
                          <Col lg="2">
                          {v.row.Parameter !== "" && v.row.Parameter !== null && <img src={openpara} onClick={e => this.toggleModalParameter(v.row.Parameter)} style={{ cursor: 'pointer', width: '30px', height: '30px' }} alt="" />
                          }
                         </Col>
                        </Row>
                        <br />
                        <div>
                          <span ><b>Log :</b>{
                            this.state.logState === false ?
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState,v.row.Id, v.row.LogFiles)}>Show</Button> :
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState,v.row.Id, v.row.LogFiles)}>Hide</Button>
                          }
                          </span>
                        </div>
                      </div>
                     }
                      showPaginationBottom={true}
                      className="-striped -highlight primary-pagination tableHeight"
                    />
          </div>   
            </Col>
          </Row>     
          </Scrollbars>

               </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div>{this.state.logState && <Dialog
              title="Logs"
              modal={true}
              onClose={this.handleClose}
            >
         <LoadingOverlay
        active={this.state.modalloading}
        spinner={<HashLoader
          size={50}
          color={"#fff"}
          loading={this.state.modalloading}
        />}
      >
              <Scrollbars style={styles.expandStyles_Comman} autoHeight autoHeightMin={400}
                thumbMinSize={30} >
                  {(this.state.fileType === "others") &&
                       <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                  {this.state.myContent.split("\n").map((i, key) => {
                    return <div key={"mycontent-" + key}>{i}</div>;
                  })}
                </p> 
                        } 
              </Scrollbars>
              </LoadingOverlay>
            </Dialog>}
            </div>
            <Modal open={open} onClose={this.onCloseModal} backdrop="static">
              <div className="chatheader">
                <span className="font14"><b>Job - {this.state.commentid}</b> - Comments</span>
              </div>
              <Scrollbars autoHeight autoHeightMin={0}
                autoHeightMax={500}
                thumbMinSize={30} className="scrollalign">

                <ul className="chatul">
                  {this.state.chatMsg.map((item,index) => (

                    <li key={"chat-msg-" + index} className="chatcontent">
                      <Linkify>
                        <Media className="align-items-center">
                          <span className="avatar avatar-sm rounded-circle" >
                            {item.photoURL === null ? (
                              <img src={profileIcon} style={{ borderRadius: '50px' }} alt="" />
                            ) : <img src={item.photoURL} alt={item.firstName} style={{ borderRadius: '50px' }}
                               />}
                          </span>
                          <Media className="ml-2 d-none d-lg-block">
                            <span className="mb-0 text-sm font-weight-bold" style={{ fontSize: '14px' }}>
                              {item.firstName + "  " + item.lastName}
                            </span>
                            <p style={{ fontSize: '12px' }}>
                              <i className="ni location_pin mr-2" />
                              {item.createdDate != null ? moment.utc(item.createdDate).local().format('MMM DD, YYYY HH:mm a') : ""}
                            </p>
                            <p><div className="chatp">{item.message}</div></p>
                          </Media>
                        </Media>
                      </Linkify>
                    </li>

                  ))}
                  <li className="chatcontent">
                    {this.state.messages.map((item, i) =>
                      <Linkify key={"msg-msg-" + i}>
                        <Media className="align-items-center">
                          <span className="avatar avatar-sm rounded-circle" >
                            {this.state.localPhoto == null ? (
                              <img src={profileIcon} style={{ borderRadius: '50px' }} alt="" />
                            ) : <img src={this.state.localPhoto} alt={this.state.localName} style={{ borderRadius: '50px' }}
                               />}
                          </span>
                          <Media className="ml-2 d-none d-lg-block">
                            <span className="mb-0 text-sm font-weight-bold" style={{ fontSize: '14px' }}>
                              {this.state.localName}
                            </span>
                            <p style={{ fontSize: '12px' }} >
                              <i className="ni location_pin mr-2" />
                              {moment.utc(new Date()).local().format('MMM DD, YYYY HH:mm a')}
                            </p>
                            <p><div className="chatp">{item}</div></p>
                          </Media>
                        </Media>
                      </Linkify>
                    )}
                    <div>
                    </div>
                  </li>
                </ul>

              </Scrollbars>
              <div className="chatfooter">
                <div style={{ bottom: 2, position: 'absolute', backgroundColor: "#efefef", right: 0, borderRadius: "17px" }}>
                  {this.state.showuserListFlag &&
                    <Scrollbars autoHeight autoHeightMin={0} autoHeightMax={130}>
                      {this.state.UserList.map((item,index) => (<ul>
                        <li key={"user-list-" + index} style={{ marginTop: "10px" }} onClick={e => this.userselectedValue(item.firstName, item.lastName, item.email)}>
                          <span className="avatar avatar-sm rounded-circle">
                            {item.photoURL == null ? (
                              <img src={profileIcon} alt="" />
                            ) : <img src={item.photoURL} alt={item.firstName}
                              />}
                          </span>
                          <span ><a href={() => false} class="text-primary" style={{ cursor: 'pointer', position: "absolute", marginTop: "10px", marginLeft: "20px" }}>{item.firstName + " " + item.lastName} </a></span></li>
                      </ul>))}
                    </Scrollbars>}
                  {this.state.input_user.map((item, index) => (<Chip
                    key={"input-user-" + index}
                    label={item}
                    onDelete={e => this.handleDelete(item)}
                  />))}
                  <Input className="form-control-alternative chattext" type="text" onChange={this.handleChange}
                    onKeyDown={this.keyPressed} autoFocus
                    value={this.state.input} placeholder="Type a message" /><br></br>
                </div>
              </div>

            </Modal>
            </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default ViewCluster;